import React from "react";
import { Button, Empty } from "antd";
import { BackendStatusBadge, ReviewStatusBadge } from "./status_badges.component";
import { formatDateTime, formatSpeed } from "../services/firestoreTracking.service";

export const SpeedingPanel = ({ records = [], onSelect, providerName, providerStatus, providerMessage }) => {
  const highestDelta = records.reduce((max, record) => {
    const nextValue = Number(record?.deltaKph);
    if (!Number.isFinite(nextValue)) return max;
    return Math.max(max, nextValue);
  }, 0);

  return <div className="rounded-[32px] border border-[#112219] bg-[linear-gradient(180deg,#0f1b15_0%,#070e0b_100%)] px-6 py-6 text-white shadow-[0_24px_70px_rgba(2,6,23,0.24)]">
    <div className="flex items-start justify-between gap-4">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.24em] text-[#6bdaaa]">Speed Terminal</div>
        <div className="mt-2 text-[1.9rem] font-semibold leading-tight text-white">Infringement Feed</div>
        <div className="mt-2 max-w-[520px] text-sm leading-7 text-[#a7c8b6]">
          Speed-limit evidence stays visible here, with posted limits resolved by the backend provider.
        </div>
      </div>
      <div className="text-right">
        <div className="text-[1.6rem] font-semibold text-white">{records.length}</div>
        <div className="text-xs uppercase tracking-[0.18em] text-[#8fb49e]">Live events</div>
      </div>
    </div>
    <div className="mt-5 flex flex-wrap items-center justify-between gap-4 rounded-[24px] border border-white/10 bg-black/25 px-4 py-4">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#8fb49e]">Highest Delta</div>
        <div className="mt-2 text-[1.2rem] font-semibold text-white">
        {highestDelta ? `+${highestDelta.toFixed(1)} km/h` : "No overspeed delta yet"}
        </div>
      </div>
      <div className="max-w-[300px] text-right text-sm text-[#b7d4c4]">
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#8fb49e]">Provider</div>
        <div className="mt-2">{providerName || "tomtom-snap-to-roads"}</div>
        <div className="mt-1 uppercase tracking-[0.12em] text-[#7da894]">{providerStatus || "unknown"}</div>
        {providerMessage ? <div className="mt-2 text-xs leading-6 text-[#94b7a4]">{providerMessage}</div> : null}
      </div>
    </div>
    <div className="mt-5 rounded-[24px] border border-white/10 bg-black/25 px-4 py-4">
      <div className="grid grid-cols-[minmax(0,1.4fr)_minmax(0,1.2fr)_auto] gap-4 px-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#7da894]">
        <div>Road</div>
        <div>Status</div>
        <div>When</div>
      </div>
      <div className="mt-4 flex flex-col gap-3">
      {records.length === 0 ? <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-5">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-[#a7c8b6]">No speeding infringements logged for this trip yet.</span>} />
      </div> : records.slice(0, 6).map((record) => <div key={record.id} className="grid grid-cols-1 gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1.2fr)_auto]">
        <div className="flex flex-col gap-1">
            <span className="font-semibold text-white">{record?.roadName || record?.roadAddress || "Road lookup pending"}</span>
            <span className="text-sm text-[#a7c8b6]">
              {formatSpeed(record?.actualSpeedKph)} against {formatSpeed(record?.speedLimitKph)}
            </span>
            {Number.isFinite(Number(record?.triggerSpeedKph)) ? <span className="text-xs text-[#7da894]">
              Triggered from {formatSpeed(record.triggerSpeedKph)}
            </span> : null}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <BackendStatusBadge status={record?.status} />
            <ReviewStatusBadge status={record?.reviewStatus} />
            {onSelect ? <Button onClick={() => onSelect?.(record)}>Review</Button> : null}
          </div>
          <div className="text-sm text-[#d2e5db]">{formatDateTime(record?.eventAt)}</div>
        </div>
      )}
      </div>
    </div>
  </div>;
};
